import { useState, useEffect, useCallback, useRef } from 'react';

const useIdleTimeout = (timeout, onTimeout, warningTimeout = null) => {
  const [showWarning, setShowWarning] = useState(false);

  const lastActivityRef = useRef(Date.now());
  const countdownIntervalRef = useRef(null);

  const resetTimer = useCallback(() => {
    lastActivityRef.current = Date.now();
    setShowWarning(false);

    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    const handleActivity = () => {
      resetTimer();
    };

    const events = ['click', 'keypress', 'scroll', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, handleActivity));

    const mainInterval = setInterval(() => {
      const timeSinceLastActivity = Date.now() - lastActivityRef.current;

      // Show warning
      if (warningTimeout && !showWarning && timeSinceLastActivity >= warningTimeout) {
        setShowWarning(true);
      }

      // Timeout
      if (timeSinceLastActivity >= timeout) {
        if (onTimeout) onTimeout();
      }
    }, 1000);

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      clearInterval(mainInterval);
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
    };
  }, [timeout, warningTimeout, onTimeout, showWarning, resetTimer]);

  return showWarning;
};

export default useIdleTimeout;